import React, { Component } from "react";
import { Redirect, Link } from 'react-router-dom';
import ReactFullpage from '@fullpage/react-fullpage';
import styles from '../assets/scss/modules/kampany.module.scss';
import twitter from "../assets/media/images/Twitter.png";
import tiktok from "../assets/media/images/Tiktok.png";
import instagram from "../assets/media/images/Instagram.png";
import facebook from "../assets/media/images/Facebook.png";
import jogasz from "../assets/media/images/jogasz.png";
import kepviselo from "../assets/media/images/kepviselo.png";
import csalad from "../assets/media/images/csalad.png";
import asset1 from "../assets/media/images/asset1.png";
import asset2 from "../assets/media/images/asset2.png";
import asset3 from "../assets/media/images/asset3.png";
import asset4 from "../assets/media/images/asset4.png";
import asset5 from "../assets/media/images/Titles/mindannyiunkHangja.png";
import asset6 from "../assets/media/images/asset6.png";
import back_btn from "../assets/media/newicons/back.png";
import forward_btn from "../assets/media/newicons/forward.png";
import back_btn_black from "../assets/media/newicons/back-black.png";
import forward_btn_black from "../assets/media/newicons/nextBlue.png";
import erikfoto from "../assets/media/images/Erik-foto.png";
import konczer_facebook from "../assets/media/images/konczer-facebook.png";
import gradiensProgram from "../assets/media/images/gradiensProgram.png";
import Footer from "../components/Footer/Footer";
import FooterResponziv from "../components/Footer/FooterResponziv";
import BackComponent from "../components/Kiegeszitok/BackComponent";
import BackComponentRespo from "../components/Kiegeszitok/BackComponentRespo";
import NavbarComponent from "../NavbarComponent";
import { Scrollbar } from "react-scrollbars-custom";



import{
	MDBContainer,
  MDBScrollbar,
	MDBRow,
	MDBCol,
	MDBCard,
	MDBCardHeader,
	MDBCardBody,
  MDBBtn,
} from 'mdbreact';

class MindannyiunkHangja extends Component {

	constructor(props) {
    super(props);
    this.state = {navbarPaddingTop: true,
									};
  };

	componentDidMount() {
		document.addEventListener("scroll", this.scrollEventListener);
	}

	componentWillUnmount() {
	}

	scrollEventListener = (event) => {
		const navPadding = window.scrollY < 100 ? true : false;
		this.setState({ navbarPaddingTop: navPadding});
	}


  render() {
		const anchors = ["program1", "program2", "program3"];
    return (
			<>
			<MDBContainer fluid className="fluid-container">
				<div className="d-none d-lg-block">
					<div className={styles.bodywrapper}>
						<BackComponent text={"OktatasMunkaVilaga"} text2={"Az oktatás és munka világa"} program={"program1"}/>
						<MDBContainer fluid className="program-container-programok">
							<Scrollbar
												id="scrollbar"
												style={{ width: "100%", height: "76vh", marginTop: "-5vh"}}
												maximalThumbYSize = {50}
												noScrollX = {true}
							>
								<MDBContainer fluid className="section" id="program">
									<div className={styles.bodywrapper3}>
										<MDBRow  center className="program-text-row-start">
										</MDBRow>
										<MDBRow  center>
											<div className="embed-responsive embed-responsive-16by9 videoformat">
												<iframe className="embed-responsive-item" src={"https://www.youtube.com/embed/3wW5mb0q-Pk"} allowFullScreen autoPlay></iframe>
											</div>
										</MDBRow>
										<MDBRow  center className="program-text-row">
											<p className="a-megyei-kozgyulesbe">Egy demokrácia akkor erős, ha az állampolgárok megfelelően informáltak,
											és hatékonyan részt tudnak venni a közügyek intézésében. Nem csoda, ha a kiváltságosoknak
											ez nem áll érdekükben és minden erejükkel akadályozni próbálják az aktív állampolgári részvételt.</p>
											<p className="a-megyei-kozgyulesbe">Bár a Fidesz hatalmát szolgáló politikai és üzleti körök célja,
											hogy ne mondhassuk el egymásnak, mit gondolunk a világról, szűkebb környezetünkről,
											mi nem hallgatunk, nem hallgathatunk el!</p>
											<p className="a-megyei-kozgyulesbe">Tatabányán éppen a választások előtt betiltották
											az önkormányzat lakossági tájékoztatási tevékenységét, jelentősen szűkítve a
											közügyekkel kapcsolatos információk elérhetőségét.</p>
										</MDBRow>
										<MDBRow  center className="program-text-row-end">
											<p className="a-megyei-kozgyulesbe">Mi ezt nem hagyjuk annyiban, a 21. században van
											lehetőség a helyi közösség tájékoztatására számos más felületen,
											mi ezekkel élni is fogunk. Tatabánya nem hallgat el!</p>
											<p className="a-megyei-kozgyulesbe">Tatán a kiváltságosok és az oligarcháik minden legális,
											féllegális és jogszerűtlen eszközzel akadályozzák, hogy elmondjuk véleményünket a megalomán és
											környezetkárosító beruházásaikról. Több mint egy éve már, hogy megakasztották a helyiek által
											kezdeményezett népszavazást. Ezt természetesen nem hagyjuk annyiban, hiszen
											Tata a mi otthonunk is. Tata nem hallgat el!</p>
											<p className="a-megyei-kozgyulesbe">Azért dolgozunk majd, hogy Bajon, Szárligeten,
											Vértesszőlősön továbbra is megmaradjanak vagy fejlődjenek a közösségi terek,
											ahol a helyiek találkozhatnak és véleményt mondhatnak közös ügyeikről.
											Baj, Szárliget és Vértesszőlős sem hallgat el!</p>
											<p className="a-megyei-kozgyulesbe">Az alábbi program nem a budapesti pártközpontokban íródott,
											nem a közpénzen hízlalt thinktankek kutatták ki, hogy mit érdemes megígérni a helyieknek.
											Ez a program az Önök, a Ti valós igényeitek alapján született meg. A személyes beszélgetések,
											a lakossági fórumok, megannyi levél és elektronikus üzenet alapján állítottuk össze a legsürgetőbb
											megoldásra váró problémákat. Engem az ellenzéki előválasztáson résztvevő polgárok tízezrei tettek az Egységben Magyarországért
											közös ellenzéki képviselőjelöltjévé.</p>
											<p className="a-megyei-kozgyulesbe">Ellenfelemet, Bencsik Jánost Orbán Viktor választotta ki a feladatra.
											Rábökött, mint egy bábura a sakktáblán, hogy itt ő legyen a helytartó, a miniszterelnök meghosszabbított keze.
											</p>
											<p className="a-megyei-kozgyulesbe">Ők a hatalom emberét akarják látni a parlamentben,
											mi az emberek hatalmát. Ők a hatalomnak akarnak egy képviselőt Tatabányán és térségében,
											mi Tatabányának és térségének akarunk egy képviselőt az Országgyűlésben.
											Ég és föld a különbség! Április 3-án csak rajtunk múlik, hogy melyiket választjuk!
											Dr. Konczer Erik vagyok, Tatabánya, Tata, Baj, Szárliget és Vértesszőlős országgyűlési képviselő-jelöltje.
											Az alábbi választási program az ajánlatom az itt élők számára a következő négy évre.</p>
										</MDBRow>

									</div>
							</MDBContainer>

						</Scrollbar>
					</MDBContainer>

					<div className="fixed-bottom d-none d-lg-block">
					<div className="gradient"/>
						<Footer/>
					</div>
				</div>
				</div>
			</MDBContainer>

			<div className="d-block d-lg-none">
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper2}>
						<BackComponentRespo navbarPaddingTop={this.state.navbarPaddingTop} text={"OktatasMunkaVilaga"} program={"program1"}/>
					</div>
					<div className={styles.bodywrapper3}>
						<img className="asset5-respo" src={asset5}></img>
						<MDBRow  center className="program-text-row-start m-0 px-3">
							<p className="jelenleg-is-ont-kepv"></p>
							<div className="embed-responsive embed-responsive-16by9 videoformat">
								<iframe className="embed-responsive-item" src={"https://www.youtube.com/embed/3wW5mb0q-Pk"} allowFullScreen autoPlay></iframe>
							</div>
							<p className="a-megyei-kozgyulesbe">Egy demokrácia akkor erős, ha az állampolgárok megfelelően informáltak,
							és hatékonyan részt tudnak venni a közügyek intézésében. Nem csoda, ha a kiváltságosoknak
							ez nem áll érdekükben és minden erejükkel akadályozni próbálják az aktív állampolgári részvételt.</p>
							<p className="a-megyei-kozgyulesbe">Bár a Fidesz hatalmát szolgáló politikai és üzleti körök célja,
							hogy ne mondhassuk el egymásnak, mit gondolunk a világról, szűkebb környezetünkről,
							mi nem hallgatunk, nem hallgathatunk el!</p>
							<p className="a-megyei-kozgyulesbe">Tatabányán éppen a választások előtt betiltották
							az önkormányzat lakossági tájékoztatási tevékenységét, jelentősen szűkítve a
							közügyekkel kapcsolatos információk elérhetőségét.</p>
						</MDBRow>
						<MDBRow  center className="program-text-row-end m-0 px-3">
							<p className="a-megyei-kozgyulesbe">Mi ezt nem hagyjuk annyiban, a 21. században van
							lehetőség a helyi közösség tájékoztatására számos más felületen,
							mi ezekkel élni is fogunk. Tatabánya nem hallgat el!</p>
							<p className="a-megyei-kozgyulesbe">Tatán a kiváltságosok és az oligarcháik minden legális,
							féllegális és jogszerűtlen eszközzel akadályozzák, hogy elmondjuk véleményünket a megalomán és
							környezetkárosító beruházásaikról. Több mint egy éve már, hogy megakasztották a helyiek által
							kezdeményezett népszavazást. Ezt természetesen nem hagyjuk annyiban, hiszen
							Tata a mi otthonunk is. Tata nem hallgat el!</p>
							<p className="a-megyei-kozgyulesbe">Bajon, Szárligeten, Vértesszőlősön sorra tűnnek el a közösségi
							terek, az információcsere megannyi lehetőségével. Azért dolgozunk, hogy újra megteremtsük
							ezeket a tereket, ahol a helyiek találkozhatnak és véleményt mondhatnak közös ügyeikről.
							Baj, Szárliget és Vértesszőlős sem hallgat el!</p>
							<p className="a-megyei-kozgyulesbe">Az alábbi program nem a budapesti pártközpontokban íródott,
							nem a közpénzen hízlalt thinktankek kutatták ki, hogy mit érdemes megígérni a helyieknek.
							Ez a program az Önök, a Ti valós igényeitek alapján született meg. A személyes beszélgetések,
							a lakossági fórumok, megannyi levél és elektronikus üzenet alapján állítottuk össze a legsürgetőbb
							megoldásra váró problémákat. Engem az ellenzéki előválasztáson résztvevő polgárok tízezrei tettek az Egységben Magyarországért
							közös ellenzéki képviselőjelöltjévé.</p>
							<p className="a-megyei-kozgyulesbe">Ellenfelemet, Bencsik Jánost Orbán Viktor választotta ki a feladatra.
							Rábökött, mint egy bábura a sakktáblán, hogy itt ő legyen a helytartó, a miniszterelnök meghosszabbított keze.
							</p>
							<p className="a-megyei-kozgyulesbe">Ők a hatalom emberét akarják látni a parlamentben,
							mi az emberek hatalmát. Ők a hatalomnak akarnak egy képviselőt Tatabányán és térségében,
							mi Tatabányának és térségének akarunk egy képviselőt az Országgyűlésben.
							Ég és föld a különbség! Április 3-án csak rajtunk múlik, hogy melyiket választjuk!
							Dr. Konczer Erik vagyok, Tatabánya, Tata, Baj, Szárliget és Vértesszőlős országgyűlési képviselő-jelöltje.
							Az alábbi választási program az ajánlatom az itt élők számára a következő négy évre.</p>
						</MDBRow>
					</div>
				</MDBContainer>
				<MDBContainer fluid className="fluid-container">
					<div className={styles.bodywrapper5}>
						<FooterResponziv/>
					</div>
				</MDBContainer>
			</div>
      </>
    );
  }
}
export default  MindannyiunkHangja;
